/*
===============================================================================================================
                                 Copyright 2025-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import css from 'styled-jsx/css';
import { getStaticCdnPath } from '@/utilities/static-build';

export const appFontsStyles = css.global`
  @font-face {
    font-family: 'Gotham Book';
    src: url('${getStaticCdnPath()}/fonts/gotham-book.otf');
  }

  @font-face {
    font-family: 'Gotham Medium';
    src: url('${getStaticCdnPath()}/fonts/Gotham-Medium.woff');
  }

  @font-face {
    font-family: 'Gotham Ultra Italic';
    src: url('${getStaticCdnPath()}/fonts/Gotham-UltraItalic.woff');
  }

  @font-face {
    font-family: 'Gotham Black';
    font-weight: bold;
    src: url('${getStaticCdnPath()}/fonts/Gotham-Black.woff');
  }

  @font-face {
    font-family: 'PublicSans';
    src: url('${getStaticCdnPath()}/fonts/PublicSans-Normal.ttf') format('truetype');
    font-weight: 400;
  }

  @font-face {
    font-family: 'PublicSans';
    src: url('${getStaticCdnPath()}/fonts/PublicSans-Medium.ttf') format('truetype');
    font-weight: 500;
  }

  @font-face {
    font-family: 'PublicSans';
    src: url('${getStaticCdnPath()}/fonts/PublicSans-SemiBold.ttf') format('truetype');
    font-weight: 600;
  }

  @font-face {
    font-family: 'PublicSans';
    src: url('${getStaticCdnPath()}/fonts/PublicSans-Bold.ttf') format('truetype');
    font-weight: 700;
  }
`;

export default {
  appFontsStyles,
};
